var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { FilterListContainer, ActiveFilterContainer, FilterItem, RemoveFilterButton, FilterItemContainer, } from './styles';
var FilterList = function (_a) {
    var onRemoveFilter = _a.onRemoveFilter, activeFilters = _a.activeFilters;
    var renderActiveFilters = useCallback(function (items) {
        if (!items) {
            return null;
        }
        var removeItem = function (item) {
            onRemoveFilter(item);
        };
        return items.map(function (item, i) { return (_jsxs(FilterItem, { children: ["".concat(item.key, " ; ").concat(item.operation.name, " ; ").concat(item.value), _jsx(RemoveFilterButton, __assign({ onClick: function () { return removeItem(item); } }, { children: _jsx("i", { style: { opacity: '0.7' }, className: "fas fa-times" }) }))] }, "".concat(item.value, "-").concat(i) || i)); });
    }, [onRemoveFilter]);
    if (activeFilters.length === 0) {
        return null;
    }
    return (_jsx(FilterListContainer, { children: _jsx(ActiveFilterContainer, { children: _jsx(FilterItemContainer, { children: renderActiveFilters(activeFilters) }) }) }));
};
export default FilterList;
